module.exports = __webpack_public_path__ + "img/button_save.431b3e18.svg";